import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { Users, BookOpen, HeartHandshake, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Empty, Loader } from "@/components/cast/Common";
import { Emblem } from "@/components/cast/Emblem";

export default function JoinInvite() {
  const { token } = useParams();
  const nav = useNavigate();
  const [g, setG] = useState<any>(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/invites/${token}`).then((r) => setG(r.data)).catch((e) => setErr(errMsg(e))); }, [token]);
  if (err) return <div className="mx-auto max-w-xl" data-testid="invite-invalid"><Empty title="Invite unavailable" body={err} /><Link to="/groups" className="mt-6 inline-block font-semibold text-[#C86D51]">Browse groups →</Link></div>;
  if (!g) return <Loader />;
  const member = ["member", "leader"].includes(g.my_status);
  const accept = async () => {
    try { const { data } = await api.post(`/invites/${token}/accept`); toast.success(`Welcome to ${g.name}`); nav(`/groups/${data.group_id}`); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="mx-auto max-w-xl">
      <div className="card-warm p-8 text-center sm:p-12" data-testid="invite-card">
        <p className="eyebrow">You're invited</p>
        <div className="mx-auto mt-6 flex h-16 w-16 items-center justify-center rounded-full bg-[#F3ECE0]">{g.focus === "support" ? <HeartHandshake className="h-7 w-7 text-[#C86D51]" /> : <BookOpen className="h-7 w-7 text-[#C86D51]" />}</div>
        <h1 className="mt-5 font-display text-4xl font-semibold text-slate-900" data-testid="invite-group-name">{g.name}</h1>
        <p className="mt-3 text-slate-600">{g.description}</p>
        <div className="mt-6 flex items-center justify-center gap-4 text-sm text-slate-500">
          <span className="flex items-center gap-1.5"><Emblem avatar={g.leader.avatar} size={24} />Led by {g.leader.username}</span>
          <span className="flex items-center gap-1"><Users className="h-4 w-4" />{g.member_count}</span>
        </div>
        <p className="mt-2 flex items-center justify-center gap-1 text-xs text-slate-400"><Clock className="h-3 w-3" />Link expires {new Date(g.expires_at).toLocaleDateString()}</p>
        {member ? <Link to={`/groups/${g.id}`} data-testid="invite-open-group" className="mt-8 inline-block rounded-full bg-[#1E293B] px-8 py-3 font-semibold text-white">You're already a member · Open</Link>
          : <Button data-testid="invite-accept-button" onClick={accept} className="mt-8 h-12 rounded-full bg-[#C86D51] px-8 text-base hover:bg-[#B35A3F]">Join group</Button>}
      </div>
    </div>
  );
}
